import { FETCH_GET, FETCH_POST } from "../../config";
import { push } from "react-router-redux";
import { emptyCart } from "./cart";
import activeDiscount from "../../helpers/activeDiscount";
import calculatePrice from "../../helpers/calculatePrice";
import {
  validateCartBeforeCheckout,
  trackCartEvent,
  getSessionId,
  resetSessionId,
} from "../../utils/cartSync";

export const CREATE_ORDER_PENDING = "CREATE_ORDER_PENDING";
export const CREATE_ORDER_FULFILLED = "CREATE_ORDER_FULFILLED";
export const CREATE_ORDER_REJECTED = "CREATE_ORDER_REJECTED";

export const FETCH_ORDERS_PENDING = "FETCH_ORDERS_PENDING";
export const FETCH_ORDERS_FULFILLED = "FETCH_ORDERS_FULFILLED";
export const FETCH_ORDERS_REJECTED = "FETCH_ORDERS_REJECTED";

export const GET_ORDER_PENDING = "GET_ORDER_PENDING";
export const GET_ORDER_FULFILLED = "GET_ORDER_FULFILLED";
export const GET_ORDER_REJECTED = "GET_ORDER_REJECTED";

export const GET_ORDER_ENQUIRY_PENDING = "GET_ORDER_ENQUIRY_PENDING";
export const GET_ORDER_ENQUIRY_FULFILLED = "GET_ORDER_ENQUIRY_FULFILLED";
export const GET_ORDER_ENQUIRY_REJECTED = "GET_ORDER_ENQUIRY_REJECTED";

export const GET_INVOICE_PDF_PENDING = "GET_INVOICE_PDF_PENDING";
export const GET_INVOICE_PDF_FULFILLED = "GET_INVOICE_PDF_FULFILLED";
export const GET_INVOICE_PDF_REJECTED = "GET_INVOICE_PDF_REJECTED";

export const orderEnquiry = (id) => {
  const query = `query($id:String){orderEnquiry(id:$id){
    id
    c_number
    payment
    address
    comment
    is_guest
    email
    first_name
    last_name
    city
    town
    postal_code
    phone
    customer {
      id
      addresses {
        id
        address_name
        first_name
        last_name
        city
        town
        postal_code
        address
        phone
        active
      }
    }
    shipping_cost
    total_price
    customer_discount
    discount
    products {
      quantity
      price
      product {
        id
        name
        image
        sale_price
        price
        slug
        categories {
          id
          discount {
            percent
            price
          }
        }
      }
    }
    created_at
    status
    history {
      comment
      status
      created_at
    }
  }}`;
  const variables = JSON.stringify({ id: id });
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_ENQUIRY_PENDING });
    try {
      const result = await FETCH_POST({ query: query, variables: variables });
      if (result.data.errors) {
        dispatch({
          type: GET_ORDER_ENQUIRY_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: GET_ORDER_ENQUIRY_FULFILLED,
          payload: result.data.data.orderEnquiry,
        });
        // dispatch(push("/"));
      }
    } catch (e) {
      dispatch({
        type: GET_ORDER_ENQUIRY_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const getOrder = (id) => {
  const query = `query($id:String){getOrder(id:$id){
    id
    c_number
    payment
    address
    comment
    first_name
    last_name
    city
    town
    postal_code
    phone
    customer {
      id
      addresses {
        id
        address_name
        first_name
        last_name
        city
        town
        postal_code
        address
        phone
        active
      }
    }
    shipping_cost
    total_price
    customer_discount
    discount
    products {
      quantity
      price
      product {
        id
        name
        image
        sale_price
        price
        slug
        categories {
          id
          discount {
            percent
            price
          }
        }
      }
    }
    created_at
    status
    history {
      comment
      status
      created_at
    }
    invoices {
      id
      invoiceNumber
      invoiceType
      uuid
      status
      dpStatus
      created_at
    }
  }}`;
  const variables = JSON.stringify({ id: id });
  return async (dispatch) => {
    dispatch({ type: GET_ORDER_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const result = await FETCH_POST({ query: query, variables: variables }, token);
        if (result.data.errors) {
          dispatch({
            type: GET_ORDER_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: GET_ORDER_FULFILLED,
            payload: result.data.data.getOrder,
          });
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: GET_ORDER_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const fetchOrders = () => {
  const query = `query={fetchOrders{id,c_number,shipping_cost,total_price,products{product{id}},created_at,status}}`;
  return async (dispatch) => {
    dispatch({ type: FETCH_ORDERS_PENDING });
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const result = await FETCH_GET(query, token);

        if (result.data.errors) {
          dispatch({
            type: FETCH_ORDERS_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: FETCH_ORDERS_FULFILLED,
            payload: result.data.data.fetchOrders,
          });
          // dispatch(push("/"));
        }
      } catch (e) {
        dispatch({
          type: FETCH_ORDERS_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));
      // TODO: login sayfasına yönlendir!
    }
  };
};

export const createNewOrderForGuest = ({
  payment,
  products,
  comment,
  ///////////
  setting,
  email,
  first_name,
  last_name,
  city,
  town,
  postal_code,
  address,
  phone,
  invoice_address,
}) => {
  const cartTotalDiscountPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((product) =>
              parseFloat(
                calculatePrice(product, activeDiscount(product.categories))
              )
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const cartTotalPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((item) =>
              item.sale_price
                ? item.quantity * item.sale_price
                : item.quantity * item.price
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const discount = parseFloat(cartTotalPrice - cartTotalDiscountPrice).toFixed(
    2
  );

  const query = `mutation($input:createOrderForGuestInput){createNewOrderForGuest(input:$input){id,c_number,email,first_name,last_name,city,town,phone,address,shipping_cost,total_price,discount,payment,is_guest,created_at,products{product{id,name},quantity,price}}}`;
  const variables = JSON.stringify({
    input: {
      session_id: getSessionId(), // Cart conversion tracking için
      email,
      status: "Onay Bekliyor", // Havale/EFT için ödeme onayı bekleniyor
      address: {
        first_name,
        last_name,
        city,
        town,
        postal_code,
        address,
        phone,
      },
      invoice_address: invoice_address
        ? {
            invoice_first_name: invoice_address.invoice_first_name,
            invoice_last_name: invoice_address.invoice_last_name,
            invoice_type: invoice_address.invoice_type,
            invoice_title: invoice_address.invoice_title,
            tax_office: invoice_address.tax_office,
            tax_number: invoice_address.tax_number,
            address: invoice_address.address,
            city: invoice_address.city,
            town: invoice_address.town,
            postal_code: invoice_address.postal_code,
            phone: invoice_address.phone,
            email: invoice_address.email,
          }
        : null,
      history: {
        status: "Onay Bekliyor",
        comment: "Sipariş oluşturuldu. Havale/EFT bekleniyor.",
        notification: false,
      },
      products: products.map((item) => ({
        product: item.id,
        quantity: item.quantity,
        price: item.sale_price
          ? parseFloat((item.sale_price * item.quantity).toFixed(2))
          : parseFloat((item.price * item.quantity).toFixed(2)),
      })),
      comment,
      payment,
      shipping_cost: parseFloat(
        cartTotalDiscountPrice >= setting.free_shipping
          ? 0
          : setting.shipping_cost
      ),

      total_price:
        cartTotalDiscountPrice >= setting.free_shipping
          ? cartTotalDiscountPrice
          : cartTotalDiscountPrice + setting.shipping_cost,
      discount,

      // total_price: parseFloat(
      //   products
      //     .map((item) =>
      //       item.sale_price
      //         ? parseFloat((item.sale_price * item.quantity).toFixed(2))
      //         : parseFloat((item.price * item.quantity).toFixed(2))
      //     )
      //     .reduce((a, b) => a + b)
      //     .toFixed(2)
      // ),
      is_guest: true,
    },
  });

  return async (dispatch) => {
    dispatch({ type: CREATE_ORDER_PENDING });

    // CRITICAL SECURITY: Validate cart before creating order
    // This ensures prices and stock are correct from backend
    try {
      await trackCartEvent("checkout_started");

      const validation = await validateCartBeforeCheckout();

      if (!validation.success) {
        dispatch({
          type: CREATE_ORDER_REJECTED,
          payload: [
            {
              message: "Sepet dogrulama basarisiz oldu. Lutfen tekrar deneyin.",
            },
          ],
        });
        return;
      }

      if (!validation.valid) {
        // Show errors to user
        const errorMessage = validation.errors.join(" ");
        dispatch({
          type: CREATE_ORDER_REJECTED,
          payload: [{ message: errorMessage }],
        });
        return;
      }

      // If there are warnings (price changes), show them but continue
      if (validation.warnings && validation.warnings.length > 0) {
        console.warn("[Checkout] Price warnings:", validation.warnings);
        // Could show a confirmation dialog here
      }

      // Proceed with order creation using backend-validated data
      const result = await FETCH_POST({ query, variables });

      if (result.data.errors) {
        dispatch({
          type: CREATE_ORDER_REJECTED,
          payload: result.data.errors,
        });
      } else {
        dispatch({
          type: CREATE_ORDER_FULFILLED,
          payload: result.data.data.createNewOrderForGuest,
        });
        dispatch(emptyCart());

        // IMPORTANT: Reset session after successful order to start fresh cart
        resetSessionId();

        // TODO: ödeme onaylandı sayfasına yönlendir
        dispatch(
          push({
            pathname: "/siparis-basarili",
            state: {
              is_guest: true,
              order: result.data.data.createNewOrderForGuest,
            },
          })
        );
      }
    } catch (e) {
      dispatch({
        type: CREATE_ORDER_REJECTED,
        payload: [{ message: e.toString() }],
      });
    }
  };
};

export const createNewOrderForCustomer = ({
  payment,
  address,
  invoice_address,
  setting,
  products,
  comment,
  customer_discount = 0,
}) => {
  const cartTotalDiscountPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((product) =>
              parseFloat(
                calculatePrice(product, activeDiscount(product.categories))
              )
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const cartTotalPrice =
    products.length > 0
      ? parseFloat(
          products
            .map((item) =>
              item.sale_price
                ? item.quantity * item.sale_price
                : item.quantity * item.price
            )
            .reduce((a, b) => a + b)
            .toFixed(2)
        )
      : 0;

  const discount = parseFloat(cartTotalPrice - cartTotalDiscountPrice).toFixed(
    2
  );

  const finalPrice = cartTotalDiscountPrice - customer_discount;

  const query = `mutation($input:createOrderForCustomerInput){createNewOrderForCustomer(input:$input){id,c_number,customer{id,full_name,email},first_name,last_name,city,town,phone,email,address,shipping_cost,discount,customer_discount,total_price,payment,is_guest,created_at,products{product{id,name},quantity,price}}}`;

  // Address tipini kontrol et - obje ise JSON string'e çevir
  let addressToSend = address;
  if (typeof address === "object" && address !== null) {
    addressToSend = JSON.stringify(address);
  }

  const variables = JSON.stringify({
    input: {
      session_id: getSessionId(), // Cart conversion tracking için
      status: "Onay Bekliyor", // Havale/EFT için ödeme onayı bekleniyor
      address: addressToSend,
      invoice_address,
      history: {
        status: "Onay Bekliyor",
        comment: "Sipariş oluşturuldu. Havale/EFT bekleniyor.",
        notification: false,
      },
      products: products.map((item) => ({
        product: item.id,
        quantity: item.quantity,
        price: item.sale_price
          ? parseFloat((item.sale_price * item.quantity).toFixed(2))
          : parseFloat((item.price * item.quantity).toFixed(2)),
      })),
      comment,
      payment,
      shipping_cost: parseFloat(
        finalPrice >= setting.free_shipping ? 0 : setting.shipping_cost
      ),
      total_price:
        finalPrice >= setting.free_shipping
          ? finalPrice
          : finalPrice + setting.shipping_cost,
      discount,
      customer_discount,
      is_guest: false,
    },
  });

  return async (dispatch) => {
    dispatch({ type: CREATE_ORDER_PENDING });
    const token = localStorage.getItem("token");
    if (token) {
      try {
        // CRITICAL SECURITY: Validate cart before creating order
        await trackCartEvent("checkout_started");

        const validation = await validateCartBeforeCheckout();

        if (!validation.success) {
          dispatch({
            type: CREATE_ORDER_REJECTED,
            payload: [
              {
                message:
                  "Sepet dogrulama basarisiz oldu. Lutfen tekrar deneyin.",
              },
            ],
          });
          return;
        }

        if (!validation.valid) {
          const errorMessage = validation.errors.join(" ");
          dispatch({
            type: CREATE_ORDER_REJECTED,
            payload: [{ message: errorMessage }],
          });
          return;
        }

        if (validation.warnings && validation.warnings.length > 0) {
          console.warn("[Checkout] Price warnings:", validation.warnings);
        }

        // Proceed with order creation
        const result = await FETCH_POST({ query, variables }, token);

        if (result.data.errors) {
          dispatch({
            type: CREATE_ORDER_REJECTED,
            payload: result.data.errors,
          });
        } else {
          dispatch({
            type: CREATE_ORDER_FULFILLED,
            payload: result.data.data.createNewOrderForCustomer,
          });
          dispatch(emptyCart());

          // IMPORTANT: Reset session after successful order to start fresh cart
          resetSessionId();

          // TODO: ödeme onaylandı sayfasına yönlendir
          dispatch(
            push({
              pathname: "/siparis-basarili",
              state: {
                is_guest: false,
                order: result.data.data.createNewOrderForCustomer,
              },
            })
          );
        }
      } catch (e) {
        dispatch({
          type: CREATE_ORDER_REJECTED,
          payload: [{ message: e.toString() }],
        });
      }
    } else {
      dispatch(push("/giris-yap"));

      // TODO: login sayfasına yönlendir!
    }
  };
};

// PayTR Online Ödeme Action Types
export const INITIATE_PAYTR_PAYMENT_PENDING = "INITIATE_PAYTR_PAYMENT_PENDING";
export const INITIATE_PAYTR_PAYMENT_FULFILLED =
  "INITIATE_PAYTR_PAYMENT_FULFILLED";
export const INITIATE_PAYTR_PAYMENT_REJECTED =
  "INITIATE_PAYTR_PAYMENT_REJECTED";

export const initiatePaytrPayment = function (paymentData) {
  var query =
    "mutation($input: PaytrPaymentInput){initiatePaytrPayment(input: $input) {success message merchant_oid payment_params { merchant_id user_ip merchant_oid email payment_type payment_amount currency test_mode non_3d merchant_ok_url merchant_fail_url user_name user_address user_phone user_basket debug_on client_lang lang paytr_token installment_count card_type no_installment max_installment }}}";
  var variables = JSON.stringify({ input: paymentData });

  return async function (dispatch) {
    dispatch({ type: INITIATE_PAYTR_PAYMENT_PENDING });
    var token = localStorage.getItem("token");

    try {
      var result = token
        ? await FETCH_POST({ query: query, variables: variables }, token)
        : await FETCH_POST({ query: query, variables: variables });

      if (result.data.errors) {
        dispatch({
          type: INITIATE_PAYTR_PAYMENT_REJECTED,
          payload: result.data.errors,
        });
      } else {
        var response = result.data.data.initiatePaytrPayment;
        if (response.success && response.payment_params) {
          dispatch({
            type: INITIATE_PAYTR_PAYMENT_FULFILLED,
            payload: response,
          });
          return response;
        } else {
          dispatch({
            type: INITIATE_PAYTR_PAYMENT_REJECTED,
            payload: { message: response.message },
          });
          return null;
        }
      }
    } catch (e) {
      dispatch({
        type: INITIATE_PAYTR_PAYMENT_REJECTED,
        payload: [{ message: e.toString() }],
      });
      return null;
    }
  };
};

export const getCustomerInvoicePdf = (orderId, invoiceUuid) => {
  var query = 'query($orderId:ID!,$invoiceUuid:String){getCustomerInvoicePdf(orderId:$orderId, invoiceUuid:$invoiceUuid)}';
  var variables = JSON.stringify({ orderId: orderId, invoiceUuid: invoiceUuid || null });
  return async (dispatch) => {
    dispatch({ type: GET_INVOICE_PDF_PENDING });
    var token = localStorage.getItem("token");
    if (token) {
      try {
        var result = await FETCH_POST({ query: query, variables: variables }, token);
        if (result.data.errors) {
          dispatch({
            type: GET_INVOICE_PDF_REJECTED,
            payload: result.data.errors,
          });
          return null;
        } else {
          var pdfData = result.data.data.getCustomerInvoicePdf;
          dispatch({
            type: GET_INVOICE_PDF_FULFILLED,
            payload: pdfData,
          });
          return pdfData;
        }
      } catch (e) {
        dispatch({
          type: GET_INVOICE_PDF_REJECTED,
          payload: [{ message: e.toString() }],
        });
        return null;
      }
    } else {
      dispatch({
        type: GET_INVOICE_PDF_REJECTED,
        payload: [{ message: "Not authenticated" }],
      });
      return null;
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/order.js